import { render, staticRenderFns } from "./MainWSC.vue?vue&type=template&id=00853116&scoped=true&"
import script from "./MainWSC.vue?vue&type=script&lang=js&"
export * from "./MainWSC.vue?vue&type=script&lang=js&"
import style0 from "./MainWSC.vue?vue&type=style&index=0&id=00853116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00853116",
  null
  
)

export default component.exports